<template>
  <div class="home">
    <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
    <PurchasingOrderList v-show="listView" @newPurchasing="onClickNewFromList" @editPurchasing="onClickEditFromList" :scroll="corY" ref="refreshList"/>
    <PurchasingOrderForm v-show="formView" :order="order" @backClicked="onBackChild" @backSaveChild="onBackSaveChild" @backClickID ="onBackParentID" />
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import PurchasingOrderList from '@/components/purchasing/PurchasingOrderList.vue'
import PurchasingOrderForm from '@/components/purchasing/PurchasingOrderForm.vue'
import Loading from 'vue-loading-overlay'
import { purchasingUrl, purchasingOrderUrl, getHeader } from '../config'
import { mapState } from 'vuex'

export default {
  name: 'Purchasing',
  components: {
    PurchasingOrderList,
    PurchasingOrderForm,
    Loading
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      order: {
        id: null,
        purchasing_no: null,
        purchasing_date: null,
        purchasing_due_date: null,
        term_due_id: '',
        ref_no: null,
        branch_no: null,
        vendor_no: null,
        subtotal: '0',
        tax_id: null,
        tax: '0',
        discount: '0',
        total: '0',
        delivery_cost: '0',
        deliver_no: null,
        status: null,
        branch: null,
        vendor: null,
        type_id: null,
        lock: null,
        company_no: null,
        ext_no: null,
        sp_no: null,
        schedule_payment_date: null,
        notes: null,
        details: [{
          id: null,
          purchasing_no: null,
          purchasing_date: null,
          branch_no: null,
          product_no: null,
          product: null,
          description: null,
          qty: null,
          qty_done: null,
          uom_id: null,
          price: '0',
          tax_id: null,
          tax: '0',
          discount: '0',
          discount_percentage: '0',
          subtotal: '0',
          total: '0',
          company_no: null,
          vendor_no: null,
          notes: null,
          queue: '0',
          uomList: [{
            id: null,
            name: null,
            ratio: '0',
            category: null
          }]
        }],
        payments: [{
          id: null,
          payment_no: null,
          purchasing_no: null,
          payment_date: null,
          price: '0',
          method_id: null,
          method: null,
          type_id: null,
          type: null,
          bank_id: null,
          bank: null,
          notes: null,
          prepayment_date: null
        }],
        purchasing: [{
          id: null,
          purchasing_no: null,
          purchasing_date: null,
          purchasing_due_date: null,
          term_due_id: '',
          ref_no: null,
          branch_no: null,
          vendor_no: null,
          subtotal: '0',
          tax_id: null,
          tax: '0',
          discount: '0',
          total: '0',
          delivery_cost: '0',
          deliver_no: null,
          status: null,
          branch: null,
          vendor: null,
          type_id: null,
          lock: null,
          company_no: null,
          ext_no: null,
          sp_no: null,
          details: [{
            id: null,
            purchasing_no: null,
            purchasing_date: null,
            branch_no: null,
            product_no: null,
            product: null,
            description: null,
            qty: null,
            qty_done: null,
            uom_id: null,
            price: '0',
            tax_id: null,
            tax: '0',
            discount: '0',
            subtotal: '0',
            total: '0'
          }]
        }],
        logs: [{
          id: null,
          log_date: null,
          ref_no: null,
          user_id: null,
          user: null,
          description: null
        }]
      },
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      }
    }
  },
  methods: {
    onClickEditFromList (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.order = value
      this.$store.dispatch('getProductListSelect', { status: null })
    },
    getEditPurchasing: function (value) {
      this.$Progress.start()
      this.loader.isLoading = true
      axios.get(purchasingUrl + '/order/' + value, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.listView = false
          this.formView = true
          this.paymentView = false
          this.order = response.data.data
          this.$Progress.finish()
          this.loader.isLoading = false
          this.$store.dispatch('getProductListSelect', { status: null })
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      var date = new Date()
      var details = []
      var company = this.companyList.find(d => d.company_no === this.authUser.company_no)
      var taxid = company ? company.tax_id : null
      var queue = 0
      for (let i = 1; i < 10; i++) {
        queue += 1
        var obj = {
          purchasing_no: null,
          purchasing_date: null,
          branch_no: null,
          product_no: null,
          product: null,
          description: null,
          qty: 1,
          qty_done: 0,
          uom_id: null,
          price: '0',
          tax_id: taxid,
          tax: '0',
          discount: '0',
          discount_percentage: '0',
          subtotal: '0',
          total: '0',
          company_no: null,
          vendor_no: null,
          notes: null,
          queue: queue,
          uomList: [{
            id: null,
            name: null,
            ratio: '0',
            category: null
          }]
        }
        details.push(obj)
      }
      // var company = this.companylist.find(d => d.company_no === this.authUser.company_no)
      // console.log(this.authUser.company_no)
      this.order = {
        id: null,
        purchasing_no: null,
        purchasing_date: date.toISOString(),
        purchasing_due_date: null,
        term_due_id: null,
        ref_no: null,
        branch_no: this.authUser.branch_no,
        vendor_no: null,
        subtotal: '0',
        tax_id: taxid,
        tax: '0',
        discount: '0',
        total: '0',
        delivery_cost: '0',
        deliver_no: null,
        status: null,
        branch: null,
        vendor: null,
        type_id: 1,
        lock: false,
        company_no: this.authUser.company_no,
        ext_no: null,
        sp_no: null,
        notes: null,
        schedule_payment_date: null,
        details: details,
        payments: [{
          id: null,
          payment_no: null,
          purchasing_no: null,
          payment_date: null,
          price: '0',
          method_id: null,
          method: null,
          type_id: null,
          type: null,
          bank_id: null,
          bank: null,
          notes: null,
          prepayment_date: null
        }],
        purchasing: [{
          id: null,
          purchasing_no: null,
          purchasing_date: null,
          purchasing_due_date: null,
          term_due_id: '',
          ref_no: null,
          branch_no: null,
          vendor_no: null,
          subtotal: '0',
          tax_id: 1,
          tax: '0',
          discount: '0',
          total: '0',
          delivery_cost: '0',
          deliver_no: null,
          status: null,
          branch: null,
          vendor: null,
          type_id: null,
          lock: null,
          company_no: null,
          ext_no: null,
          sp_no: null,
          details: [{
            id: null,
            purchasing_no: null,
            purchasing_date: null,
            branch_no: null,
            product_no: null,
            product: null,
            description: null,
            qty: null,
            qty_done: null,
            uom_id: null,
            price: '0',
            tax_id: null,
            tax: '0',
            discount: '0',
            subtotal: '0',
            total: '0'
          }]
        }],
        logs: [{
          id: null,
          log_date: null,
          ref_no: null,
          user_id: null,
          user: null,
          description: null
        }]
      }
      this.$store.dispatch('getProductListSelect', { status: null })
    },
    onBackParentID: function (id) {
      console.log(purchasingOrderUrl + '/' + id)
      axios.get(purchasingOrderUrl + '/' + id, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.onClickEditFromList(response.data.data)
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error!!!',
            error.response.data.message,
            'error'
          )
        })
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.order = {
        id: null,
        purchasing_no: null,
        purchasing_date: null,
        purchasing_due_date: null,
        term_due_id: '',
        ref_no: null,
        branch_no: null,
        vendor_no: null,
        subtotal: '0',
        tax_id: null,
        tax: '0',
        discount: '0',
        total: '0',
        delivery_cost: '0',
        deliver_no: null,
        status: null,
        branch: null,
        vendor: null,
        type_id: null,
        lock: null,
        company_no: null,
        ext_no: null,
        sp_no: null,
        notes: null,
        schedule_payment_date: null,
        details: [{
          id: null,
          purchasing_no: null,
          purchasing_date: null,
          branch_no: null,
          product_no: null,
          product: null,
          description: null,
          qty: null,
          qty_done: null,
          uom_id: null,
          price: '0',
          tax_id: null,
          tax: '0',
          discount: '0',
          discount_percentage: '0',
          subtotal: '0',
          total: '0',
          company_no: null,
          vendor_no: null,
          notes: null,
          queue: '0',
          uomList: [{
            id: null,
            name: null,
            ratio: '0',
            category: null
          }]
        }],
        payments: [{
          id: null,
          payment_no: null,
          purchasing_no: null,
          payment_date: null,
          price: '0',
          method_id: null,
          method: null,
          type_id: null,
          type: null,
          bank_id: null,
          bank: null,
          notes: null,
          prepayment_date: null
        }],
        purchasing: [{
          id: null,
          purchasing_no: null,
          purchasing_date: null,
          purchasing_due_date: null,
          term_due_id: '',
          ref_no: null,
          branch_no: null,
          vendor_no: null,
          subtotal: '0',
          tax_id: null,
          tax: '0',
          discount: '0',
          total: '0',
          delivery_cost: '0',
          deliver_no: null,
          status: null,
          branch: null,
          vendor: null,
          type_id: null,
          lock: null,
          company_no: null,
          ext_no: null,
          sp_no: null,
          details: [{
            id: null,
            purchasing_no: null,
            purchasing_date: null,
            branch_no: null,
            product_no: null,
            product: null,
            description: null,
            qty: null,
            qty_done: null,
            uom_id: null,
            price: '0',
            tax_id: null,
            tax: '0',
            discount: '0',
            subtotal: '0',
            total: '0'
          }]
        }],
        logs: [{
          id: null,
          log_date: null,
          ref_no: null,
          user_id: null,
          user: null,
          description: null
        }]
      }
      const query = Object.assign({}, this.$route.query)
      if (query) {
        delete query.purchasing
        delete query.form
        // this.$router.replace({ query })
      }
      // this.$router.replace({ path: 'purchasing', query: null })
    },
    onBackSaveChild () {
      this.listView = true
      this.formView = false
      this.order = {
        id: null,
        purchasing_no: null,
        purchasing_date: null,
        purchasing_due_date: null,
        term_due_id: '',
        ref_no: null,
        branch_no: null,
        vendor_no: null,
        subtotal: '0',
        tax_id: null,
        tax: '0',
        discount: '0',
        total: '0',
        delivery_cost: '0',
        deliver_no: null,
        status: null,
        branch: null,
        vendor: null,
        type_id: null,
        lock: null,
        company_no: null,
        ext_no: null,
        sp_no: null,
        notes: null,
        schedule_payment_date: null,
        details: [{
          id: null,
          purchasing_no: null,
          purchasing_date: null,
          branch_no: null,
          product_no: null,
          product: null,
          description: null,
          qty: null,
          qty_done: null,
          uom_id: null,
          price: '0',
          tax_id: null,
          tax: '0',
          discount: '0',
          discount_percentage: '0',
          subtotal: '0',
          total: '0',
          company_no: null,
          vendor_no: null,
          notes: null,
          queue: '0',
          uomList: [{
            id: null,
            name: null,
            ratio: '0',
            category: null
          }]
        }],
        payments: [{
          id: null,
          payment_no: null,
          purchasing_no: null,
          payment_date: null,
          price: '0',
          method_id: null,
          method: null,
          type_id: null,
          type: null,
          bank_id: null,
          bank: null,
          notes: null,
          prepayment_date: null
        }],
        purchasing: [{
          id: null,
          purchasing_no: null,
          purchasing_date: null,
          purchasing_due_date: null,
          term_due_id: '',
          ref_no: null,
          branch_no: null,
          vendor_no: null,
          subtotal: '0',
          tax_id: null,
          tax: '0',
          discount: '0',
          total: '0',
          delivery_cost: '0',
          deliver_no: null,
          status: null,
          branch: null,
          vendor: null,
          type_id: null,
          lock: null,
          company_no: null,
          ext_no: null,
          sp_no: null,
          details: [{
            id: null,
            purchasing_no: null,
            purchasing_date: null,
            branch_no: null,
            product_no: null,
            product: null,
            description: null,
            qty: null,
            qty_done: null,
            uom_id: null,
            price: '0',
            tax_id: null,
            tax: '0',
            discount: '0',
            subtotal: '0',
            total: '0'
          }]
        }],
        logs: [{
          id: null,
          log_date: null,
          ref_no: null,
          user_id: null,
          user: null,
          description: null
        }]
      }
      const query = Object.assign({}, this.$route.query)
      if (query) {
        delete query.purchasing
        delete query.form
      }
      this.$refs.refreshList.refreshPurchasing()
    },
    onClickPaymentFromForm: function (value) {
      this.purchasing = value
      this.listView = false
      this.formView = false
    },
    cancelPayment: function (id) {
      this.getEditPurchasing(id)
    }
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser,
      taxList: state => state.taxes.taxList,
      companyList: state => state.companies.companyList
    })
  },
  mounted () {
    this.$store.dispatch('getTermDueList')
    this.$store.dispatch('getVendorList')
    this.$store.dispatch('getBranchList')
    this.$store.dispatch('getTaxList')
    this.$store.dispatch('getUomList')
    this.$store.dispatch('getRowTable')
    this.$store.dispatch('getPaymentTypeList')
    this.$store.dispatch('getPaymentMethodList')
    this.$store.dispatch('getPurchasingTypeList')
    this.$store.dispatch('getBankList')
    this.$store.dispatch('getPurchasingTypeList')
    this.$store.dispatch('getCompanyList')
    // get query param from url
    var form = this.$route.query.form
    var purchasing = this.$route.query.purchasing
    if (form === 'true') {
      if (purchasing !== null) {
        this.getEditPurchasing(purchasing)
      }
    }
  }
}
</script>
